



























































































































import CompanyUserRequired from "../../CompanyRequired";
import {Component, Inject, Watch} from "vue-property-decorator";
import AddPerson from "@/components/users/reports/AddPerson.vue";
import {DateTime, GuiUserlisting, PhoneNumber, TerminalLocationShortInfo} from "@/modules/models";
import PersonMarker from "@/components/PersonMarker.vue";
import ChooseDateIntervalDialog from "@/components/users/reports/ChooseDateIntervalDialog.vue";
import {InfectionTraceRow, PersonRefAndDateInterval, TerminalLocationInfoDateInterval} from "@/modules/reportmodels";
import Api from "@/components/users/reports/Api";
import AddLocation from "@/components/users/reports/AddLocation.vue";
import InfectionTraceInfoTxt from "@/components/docs/infectiontrace/InfectionTraceInfoTxt.vue";
import InfoBtn from "@/components/shared/InfoBtn.vue";
import InfoDialog from "@/components/InfoDialog.vue";

class GuilistingAndDateInterval {
  public constructor(public person: GuiUserlisting, public from: DateTime, public to: DateTime) {}
}

@Component({
  components: {
    "at-add-person": AddPerson,
    "at-person-marker": PersonMarker,
    "at-choose-date-interval": ChooseDateIntervalDialog,
    "at-add-location": AddLocation,
    "at-infectiontrace-info-txt": InfectionTraceInfoTxt,
    "at-info-btn": InfoBtn,
    "at-info-dlg": InfoDialog,
  }
})
export default class InfectionTracer extends CompanyUserRequired {
  @Inject()
  api!: Api;

  showAddPersonDlg = false;

  personSelected(person: GuiUserlisting) {
    this.showAddPersonDlg = false;
    this.chooseDateIntervalPerson = person;
    this.showChooseDateIntervalDlg = true;
  }

  chooseDateIntervalPerson: GuiUserlisting | null = null;

  showChooseDateIntervalDlg = false;

  dateIntervalChosen(from: DateTime, to: DateTime) {
    if(this.chooseDateIntervalPerson != null) {
      this.selectedPersons.push(new GuilistingAndDateInterval(this.chooseDateIntervalPerson, from, to));
      this.chooseDateIntervalPerson = null;
    } else if(this.chooseDateIntervalLoc != null) {
      this.locationsAdded.push(new TerminalLocationInfoDateInterval(this.chooseDateIntervalLoc, from, to));
      this.chooseDateIntervalLoc = null;
    }
    this.showChooseDateIntervalDlg = false;
  }

  selectedPersons: GuilistingAndDateInterval[] = [];
  loadingLocs = false;

  removeSelectedPerson(selected: GuilistingAndDateInterval) {
    this.selectedPersons = this.selectedPersons.filter(r => r.person.guid != selected.person.guid || !r.from.equals(selected.from) || !r.to.equals(selected.to));
  }

  @Watch("selectedPersons", {deep: true})
  async onSelectedPersonsChanged() {
    if(this.selectedPersons.length > 0) {
      this.loadingLocs = true;
      try {
        const personsAndIntervals = this.selectedPersons.map(r => new PersonRefAndDateInterval(r.person.guid, r.from, r.to));
        this.locationsFromPersons = await this.api.fetchInfectiousPersonsLocations(personsAndIntervals);
      } finally {
        this.loadingLocs = false;
      }
    } else {
      this.locationsFromPersons = [];
    }
  }

  locationsFromPersons: TerminalLocationInfoDateInterval[] = [];

  locationsAdded: TerminalLocationInfoDateInterval[] = [];

  get locationIntervals() {
    return [...this.locationsFromPersons, ...this.locationsAdded];
  }

  loadingResult = false;

  rows: InfectionTraceRow[] = [];

  @Watch("locationIntervals")
  async onLocationIntervalsChanged() {
    if(this.locationIntervals.length > 0) {
      this.loadingResult = true;
      try {
        this.rows = await  this.api.fetchInfectionTrace(this.locationIntervals);
      } finally {
        this.loadingResult = false;
      }
    }
  }

  headers = [
    {text: "Fornavn", value: "firstName", sortable: false},
    {text: "Etternavn", value: "lastName", sortable: false},
    {text: "Født", value: "birthDate", sortable: false},
    {text: "Firma", value: "companyName", sortable: false},
    {text: "Telefon", value: "phones", sortable: false},
  ]

  formatDate(dt: DateTime | null): string | null {
    return dt != null ? dt.toLocalDate() : null;
  }

  showAddLocationDlg = false;

  chooseDateIntervalLoc: TerminalLocationShortInfo | null = null;

  locationSelected(loc: TerminalLocationShortInfo) {
    this.showAddLocationDlg = false;
    this.chooseDateIntervalLoc = loc;
    this.showChooseDateIntervalDlg = true;
  }

  removeSelectedLocation(selected: TerminalLocationInfoDateInterval) {
    this.locationsAdded = this.locationsAdded.filter(loc => loc.terminalLocationInfo.id != selected.terminalLocationInfo.id || !loc.from.equals(selected.from) || !loc.to.equals(selected.to));
  }

  async xlsxOut() {
    await this.api.xlsxInfectionTrace(this.selectedPersons, this.locationIntervals);
  }

  showInfoDlg = false;
}
